import * as React from 'react'
require('../base.module.scss')
import {
    BaseComponentProps,
    extractClassNamesFromProps,
} from '../Common'
import * as st from './Badge.module.scss'

export const badges = {
    REGULATORY_RATING: st['regulatory-rating'],
    BORDERED_TEXT: st['bordered-text'],
    LIVE: st.live,
    TEXT: st.text,
    CRITICAL: st.critical,
    WHITE: st.white
}

interface BadgeProps extends BaseComponentProps {
    use: string
    title?: string
}

export const Badge: React.ComponentType<BadgeProps> = (props) => {
    const className = extractClassNamesFromProps(props, props.use)
    return (
        <span className={className} title={props.title}>
            {props.children}
        </span>
    )
}

// Add displayName to preserve the component name on snapshot testing
Badge.displayName = 'Badge'
